import { Box } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";

export interface IInfiniteScrollerProps {
  fetchMoreData: any;
  hasMore: boolean;
  children: any;
  dataLength: number;
}
const InfiniteScroller = ({
  fetchMoreData,
  hasMore,
  children,
  dataLength,
}: IInfiniteScrollerProps) => {
  return (
    <>
      <Box sx={{ marginBottom: "2rem" }}>
        <InfiniteScroll
          dataLength={dataLength}
          next={fetchMoreData}
          scrollThreshold={0.7}
          loader={
            <div className="loader" key={0}>
              Loading ...
            </div>
          }
          hasMore={hasMore}
        >
          {children}
        </InfiniteScroll>
      </Box>
    </>
  );
};
export default InfiniteScroller;
